/**
 * @author robin
 * @description 用于维护需要接收类型为导出表格的文字流请求地址
 */
export default [
    // oms
    `/oms/performance/export`,
   
]



// WEBPACK FOOTER //
// ./src/xhr/exportXlsEnum.js